import useSWR from "swr";


export const useFetchCurrentGoogleRating = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `/external_api/restaurants/${restaurantId}/google/rating/current` : null;
  const { data: currentRating, error, isLoading } = useSWR<number>(fetcherKey);
  return { currentRating, isLoading, error };
};